<template>
  <output
    v-if="serviceWorkerUpdating"
    class="sw-update-overlay"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="sw-update-card">
      <div class="sw-update-spinner" aria-hidden="true"></div>
      <div class="sw-update-title">App wordt bijgewerkt</div>
      <div class="sw-update-text">Ogenblik geduld, we laden de nieuwste versie.</div>
    </div>
  </output>

  <RouterView />
  <InstallPopup />
  <SessionTimeout />
  <div id="theme-reveal"></div>
  <Toast class="max-w-[calc(100vw-40px)]" position="top-right">
    <template #message="slotProps">
      <div class="flex flex-col items-start flex-auto">
        <div class="flex items-center gap-2">
          <i :class="slotProps.message.icon"></i>
          {{ slotProps.message.summary }}
        </div>
      </div>
    </template>
  </Toast>
</template>

<script>
import InstallPopup from "./components/AppInstallation/InstallPopup.vue";
import SessionTimeout from "./components/SessionTimeout.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    InstallPopup,
    SessionTimeout,
  },

  computed: {
    ...mapGetters([
      'serviceWorkerUpdating',
      'themeMode',
    ])
  },

  created() {
    this.applyTheme()
  },

  mounted() {
    this.systemThemeMedia = window.matchMedia('(prefers-color-scheme: dark)');
    this.systemThemeMedia.addEventListener?.('change', this.handleSystemThemeChange);
  },

  beforeUnmount() {
    this.systemThemeMedia?.removeEventListener?.('change', this.handleSystemThemeChange);
  },

  methods: {
    applyTheme() {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const shouldUseDark = this.themeMode === 'system' ? prefersDark : this.themeMode === 'dark';

      this.$store.commit('SET_DARK_MODE', shouldUseDark);
      document.documentElement.classList.toggle('dark', shouldUseDark);
    },

    handleSystemThemeChange() {
      if (this.themeMode === 'system') {
        this.applyTheme();
      }
    },
  },

  watch: {
    themeMode() {
      this.applyTheme();
    },
  },
}
</script>

<style scoped>
.sw-update-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  padding-top: calc(env(safe-area-inset-top, 0px) + 1rem);
  padding-right: max(1rem, env(safe-area-inset-right, 0px));
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 1rem);
  padding-left: max(1rem, env(safe-area-inset-left, 0px));
  background: rgba(2, 6, 23, 0.74);
  backdrop-filter: blur(4px);
}

.sw-update-card {
  width: min(560px, 100%);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.45);
  padding: 28px 24px;
  text-align: center;
}

.sw-update-spinner {
  width: 52px;
  height: 52px;
  margin: 0 auto 16px;
  border-radius: 9999px;
  border: 4px solid #e2e8f0;
  border-top-color: #0ea5e9;
  animation: sw-rotate 0.9s linear infinite;
}

.sw-update-title {
  color: #0f172a;
  font-size: 1.375rem;
  line-height: 1.2;
  font-weight: 700;
}

.sw-update-text {
  margin-top: 8px;
  color: #475569;
  font-size: 0.98rem;
}

@keyframes sw-rotate {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 640px) {
  .sw-update-card {
    width: 100%;
    border-radius: 16px;
    padding: 24px 18px;
  }

  .sw-update-title {
    font-size: 1.2rem;
  }
}
</style>
